import "choerodon-ui/lib/locale-provider/style";
import _LocaleProvider from "choerodon-ui/lib/locale-provider";
import "hzero-ui/lib/config-provider/style";
import _ConfigProvider from "hzero-ui/lib/config-provider";
import _localeContext from "choerodon-ui/pro/lib/locale-context";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _createSuper from "@babel/runtime/helpers/esm/createSuper";
var _dec, _class;
import React, { Component } from 'react';
import { connect } from 'dva';
import { getEnvConfig } from "../iocUtils";
import { resolveRequire } from "../utils";
var _getEnvConfig = getEnvConfig(),
  configureParams = _getEnvConfig.configureParams;
var LocalProviderAsync = (_dec = connect(function (_ref) {
  var _ref$global = _ref.global,
    global = _ref$global === void 0 ? {} : _ref$global;
  return {
    language: global.language,
    hzeroUILocale: global.hzeroUILocale,
    c7nLocale: global.c7nLocale,
    supportLanguage: global.supportLanguage
  };
}), _dec(_class = /*#__PURE__*/function (_Component) {
  _inherits(LocalProviderAsync, _Component);
  var _super = _createSuper(LocalProviderAsync);
  function LocalProviderAsync() {
    _classCallCheck(this, LocalProviderAsync);
    return _super.apply(this, arguments);
  }
  _createClass(LocalProviderAsync, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var _this$props = this.props,
        supportLanguage = _this$props.supportLanguage,
        language = _this$props.language;
      if (prevProps.supportLanguage !== supportLanguage) {
        var c7nLocaleContext = {};
        if (supportLanguage) {
          supportLanguage.forEach(function (intlRecord) {
            c7nLocaleContext[intlRecord.code] = intlRecord.name;
          });
        } // 更新 c7n 的 locale supports

        _localeContext.setSupports(c7nLocaleContext);
      }
      if (prevProps.language !== language && language) {// c7n localeContext already update in models/global; so not need updatet there
        // localeContext.setLocale(language); // this is error, locale should be a deep object with intl;
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
        hzeroUILocale = _this$props2.hzeroUILocale,
        c7nLocale = _this$props2.c7nLocale;
      var config = {
        modalMovable: configureParams === null || configureParams === void 0 ? void 0 : configureParams.modalMovable,
        modalAutoCenter: configureParams === null || configureParams === void 0 ? void 0 : configureParams.modalAutoCenter
      };
      return /*#__PURE__*/React.createElement(_LocaleProvider, {
        locale: resolveRequire(c7nLocale)
      }, /*#__PURE__*/React.createElement(_ConfigProvider, Object.assign({}, config, this.props, {
        locale: resolveRequire(hzeroUILocale)
      })));
    }
  }]);
  return LocalProviderAsync;
}(Component)) || _class);
export { LocalProviderAsync as default };